import { render, staticRenderFns } from "./PartnersManagement.vue?vue&type=template&id=7f1aee76&"
import script from "./PartnersManagement.vue?vue&type=script&lang=js&"
export * from "./PartnersManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports